import { IFinancialReducer } from "../../reducer-model/financial/IFinancialReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IFinancialReducer = {
    status: eReducerStatusBase.is_not_initialization,
    data: null,
    error_message: "",
};

export const financialReducer = (state: IFinancialReducer = initialState, action: any): IFinancialReducer => {
    switch (action.type) {
        case "FINANCIAL_LOAD_START":
            // Giữ data cũ khi poll lại — không flash "đang tải" mỗi 60s.
            return state.data ? state : { ...state, status: eReducerStatusBase.is_loading };
        case "FINANCIAL_LOAD_SUCCESS":
            return { ...state, status: eReducerStatusBase.is_completed, data: action.payload, error_message: "" };
        case "FINANCIAL_LOAD_ERROR":
            return { ...state, status: eReducerStatusBase.is_error, error_message: action.payload };
        default:
            return state;
    }
};
